import React, { useEffect, useState } from "react";
import { IoMdMenu, IoMdArrowDropdown } from "react-icons/io";
import { Link, useLocation } from "react-router-dom";
import { PiSignInBold } from "react-icons/pi";
import { FaUserPlus } from "react-icons/fa";

let NavLinks = [
  { title: "Home", Link: "/" },
  { title: "About", Link: "/about" },
  { title: "Accessories", Link: "/accessories" },
  { title: "Contact", Link: "/contact" },
];

function BtmHeader() {
  let [isCategoryOpen, setisCategoryOpen] = useState(false);
  let location = useLocation();
  let [categories, setcategories] = useState([]);

  useEffect(() => {
    setisCategoryOpen(false);
  }, [location]);

  useEffect(() => {
    fetch("https://dummyjson.com/products/categories")
      .then((res) => res.json())
      .then((data) => setcategories(data));
  }, []);

  return (
    <div className="btn-heder">
      <div className="Container">
        <div className="nav">
          <div
            className="Categoty-nav"
            onClick={() => setisCategoryOpen(!isCategoryOpen)}
          >
            <div className="Category-btn">
              <IoMdMenu />
              <p>Browse Category</p>
              <IoMdArrowDropdown />
            </div>
            <div
              className={`Category-nave-list ${isCategoryOpen ? "active" : ""}`}
            >
              {categories.map((category) => (
                <Link key={category.slug} to={`category/${category.slug}`}>
                  {category.name}
                </Link>
              ))}
            </div>
          </div>

          <div className="nav-links">
            {NavLinks.map((item) => (
              <li
                key={item.Link}
                className={location.pathname === item.Link ? "active" : ""}
              >
                <Link Link to={item.Link}>
                  {item.title}{" "}
                </Link>
              </li>
            ))}
          </div>
        </div>
        <div className="sign-regs-icons">
          <Link to="/">
            <PiSignInBold />
          </Link>
          <Link to="/">
            <FaUserPlus />
          </Link>
        </div>
      </div>
    </div>
  );
}

export default BtmHeader;
